import axios from '@/services/'

export default {
  fetchCountries: async (serviceTransactionId) => {
    const data = await axios.get('/api/lookup/countries', { params: { serviceTransactionId } })
    return data
  },
  fetchEstablishmentInfo: async () => {
    const data = await axios.get('/api/establishment/info', {})
    return data
  }
}
